import { useContext } from "react";
import { ICphDataContextType } from "../types/interfaces/ICphDataContextType";
import { CphDataContext } from "../contexts/CphDataContext";

//This custom hook is responsible for consuming the cph data context.
export function useCphDataContext(): ICphDataContextType {
    const context = useContext(CphDataContext);

    if (!context) {
        throw new Error('The useCphDataContext must be used within a CphDataProvider.');
    }

    return context;
}